var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconItemBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E13C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.707 4.293a1 1 0 00-1.414 1.414l1.414-1.414zm4.586 7.414a1 1 0 001.414-1.414l-1.414 1.414zm-6-6l6 6 1.414-1.414-6-6-1.414 1.414z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 4.293a1 1 0 111.414 1.414l-1.414-1.414zm-4.586 7.414a1 1 0 01-1.414-1.414l1.414 1.414zm6-6l-6 6-1.414-1.414 6-6 1.414 1.414z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconItemBlocked);
export default __webpack_public_path__ + "static/media/icon-item-blocked.7b1edde2ed36d50338134a7f0be60ab3.svg";
export { ForwardRef as ReactComponent };